import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfBulkDownloadProcessingDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  pdfDownloadProcessModalHeaderTitle: 'SDSのダウンロードが進行中です。',
  pdfDownloadProcessModalBodyFText: '宛先SDSファイルの一括ダウンロード中です。',
});





const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const closeDialog = () => {
  model.value = false;
};

const handleCloseClick = () => {
  closeDialog();
};

return { __sfc: true,$t, m, props, emit, model, closeDialog, handleCloseClick, sharedMessages }
}

})